<template>
	<div class="carousel">
		<img v-for="(imgSrc, index) in images" :class="[{'active': isCurrentIndex(index)}]" :src="imgSrc" :key="imgSrc">
	</div>
</template>

<script>
	export default {
		name: "ImageCarousel",
		props: {
			images: Array
		},
		data: function() {
			return {
				sharedStore: window.store,
				imageIndex: 0,
				cycleInterval: ""
			}
		},
		mounted: function() {
			this.cycleInterval = setInterval(this.cycleImages, 3000);
		},
		computed: {
			
		},
		methods: {
			test: function() {
				console.log("test");
			},
			isCurrentIndex: function(i) {
				return this.imageIndex === i;
			},
			cycleImages: function() {
				this.imageIndex++;
				if (typeof this.images === "undefined" || this.imageIndex >= this.images.length) {
					this.imageIndex = 0;
				}
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	.carousel {
		position: relative;
		width: 100%;
		height: 100%;
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		opacity: 0;
		transition: 0.5s;

		&.active {
			opacity: 1;
		}
	}
</style>